/**
 * @file Portal atom — overlay/teleport primitive family.
 * @description structured atom: compound parts re-exported from the vendored
 * Gluestack family; this is the only sanctioned import path for app code
 * (RFC §3).
 * @module components/atoms/Portal
 */
export {
  PLAYER_DETAIL_PORTAL,
  Portal,
  GorhomPortal,
  PortalHost,
  PortalProvider,
} from "@/components/ui/portal";
